export default __webpack_public_path__ + "static/media/MP.e142ed58.svg";